import { runPersonalizationRules } from "./personalization";
import getCondition from "./personalization/conditions";

const getCopyByReferrer = (referrerPath) => {
  switch (referrerPath) {
    case "/platform/incident-management/":
    case "/platform/incident-management/on-call-management/":
    case "/platform/incident-management/on-call-management/mobile/":
    case "/platform/incident-management/incident-response/":
    case "/platform/incident-management/stakeholder-communication/":
    case "/solutions/incident-management-transformation/":
      return "Resolve Issues 70% Faster";
    case "/platform/automation/":
    case "/platform/automation/runbook/":
    case "/platform/automation/workflow/":
    case "/platform/automation/process-software/":
      return "Experience 99% Faster Task Resolution";
    case "/platform/business-ops/":
    case "/platform/business-ops/customer-service-operations/":
    case "/platform/business-ops/status-pages/":
    case "/solutions/cx-operations/":
      return "74% Less Downtime Means Happier Customers";
    case "/platform/aiops/":
      return "87% Less Noise. <br class='hidden md:flex'> 100% More Innovation.";
    case "/platform/operations-cloud/":
      return "Ready to Reduce Alert Noise by 87%? Let's Talk";
    default:
      return "";
  }
};

/** @type {import("./personalization/global-rules").PersonalizationRule} */
const personalizedFormIntroCopy = {
  id: "form-intro-copy-referrer",
  name: "Form Intro Copy by Referrer",
  conditions: [
    getCondition("isEnglishLang"),
    () => {
      if (!document.referrer) return false;
      const referrer = new URL(document.referrer);
      const referrerPath = referrer.pathname;
      return getCopyByReferrer(referrerPath) !== "";
    },
  ],
  actions: [
    () => {
      const h2 = document.querySelector("#embargoed-form h2");
      const referrer = new URL(document.referrer);
      const referrerPath = referrer.pathname;
      if (h2 && getCopyByReferrer(referrerPath)) {
        h2.innerHTML = getCopyByReferrer(referrerPath);
      }
    },
  ],
};

// Referrer-based personalization is disabled temporarily while new default copy is being tested.
// Once testing is complete, this should be re-enabled.

runPersonalizationRules([personalizedFormIntroCopy]);
